import { AssociatedPersonnelThemeModeConfig } from './types';

const light: AssociatedPersonnelThemeModeConfig = {
  associatedPersonnel: {},
};

export default light;
